import React, { useState } from 'react';
import type { CommentAudience } from '../../utils/commentAudience';
import './CommentAudienceControl.css';

export interface CommentAudienceControlProps {
  audience: CommentAudience;
  onChange: (next: CommentAudience) => void;
  architectName: string;
  hasAssignedArchitect: boolean;
  disabled?: boolean;
}

export const CommentAudienceControl: React.FC<CommentAudienceControlProps> = ({
  audience,
  onChange,
  architectName,
  hasAssignedArchitect,
  disabled = false,
}) => {
  const [hint, setHint] = useState<CommentAudience | null>(null);
  const askLabel = hasAssignedArchitect ? `Ask architect · ${architectName}` : 'Ask architect';

  return (
    <div className="cac-wrap">
      <div className="cac-seg" role="radiogroup" aria-label="Comment audience">
        <button
          type="button"
          role="radio"
          aria-checked={audience === 'internal'}
          className={`cac-opt${audience === 'internal' ? ' cac-opt--active' : ''}`}
          disabled={disabled}
          onClick={() => onChange('internal')}
          onMouseEnter={() => setHint('internal')}
          onMouseLeave={() => setHint(null)}
          onFocus={() => setHint('internal')}
          onBlur={() => setHint(null)}
        >
          Working notes
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={audience === 'architect'}
          className={`cac-opt${audience === 'architect' ? ' cac-opt--active cac-opt--ask' : ''}`}
          disabled={disabled || !hasAssignedArchitect}
          onClick={() => hasAssignedArchitect && onChange('architect')}
          onMouseEnter={() => setHint('architect')}
          onMouseLeave={() => setHint(null)}
          onFocus={() => setHint('architect')}
          onBlur={() => setHint(null)}
        >
          {askLabel}
        </button>
      </div>
      {hint === 'internal' && (
        <div className="cac-pop" role="tooltip">
          Keep the back-and-forth here so the architect is not in the weeds.
        </div>
      )}
      {hint === 'architect' && (
        <div className="cac-pop" role="tooltip">
          {hasAssignedArchitect
            ? 'Loop them in on a decision that needs their call.'
            : 'Assign an architect on the project first.'}
        </div>
      )}
    </div>
  );
};

export default CommentAudienceControl;
